<template>
    <modal name="popupPaymentSchedule"
           @before-open="beforeOpen"
           :width="defaultOptions.width"
           :min-width="defaultOptions.minWidth"
           :max-width="defaultOptions.maxWidth"
           :height="defaultOptions.height"
           :adaptive="defaultOptions.adaptive"
    >
        <div class="cabinet-modal">
            <button class="cabinet-modal__close-modal" v-on:click="$modal.hide('popupPaymentSchedule')">
                <svg width="16px" height="16px" enable-background="new 0 0 371.23 371.23" version="1.1" viewBox="0 0 371.23 371.23" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                <polygon class="modal-close" points="371.23 21.213 350.02 0 185.62 164.4 21.213 0 0 21.213 164.4 185.62 0 350.02 21.213 371.23 185.62 206.83 350.02 371.23 371.23 350.02 206.83 185.62"/>
                </svg>
            </button>
            <section class="cabinet-modal__header">
                <h3 class="cabinet-modal__header-title">Календарь платежей</h3>
            </section>
            <section class="cabinet-modal__body">
                <div class="cabinet-modal__col-1-2">
                    <payment-shedule></payment-shedule>
                </div>
                <div class="cabinet-modal__col-1-2">

                </div>
            </section>
        </div>


    </modal>
</template>

<script>

    import widthMixin from '@/modules/mixins/widthMixin'
    import {STATUSES} from "@/components/statuses";

    export default {
        name: 'popupPaymentSchedule',
        mixins: [widthMixin],
        data() {
            return {
                defaultOptions: {
                    adaptive: true,
                    minWidth: 320,
                    maxWidth: 690,
                    width: '100%',
                    height: 'auto'
                },
            }
        },
        methods: {
            beforeOpen(event) {
                this.amountToPay = event.params.amountToPay;
                this.amountOfPayment = event.params.amountOfPayment;
                this.balance = event.params.balance;
            }
        },
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .cabinet-modal {
        &__col-1-2{
            max-width: 50%;
            width: 100%;
        }
    }
</style>